
import {lazy} from 'react';

// console.log(import('../../pages/uploadAddress/index.js'));

const UploadAddress = [{
  title: '无人零售分众H5-首页',
  path: '/uploadAddressFocus/home',
  key: 'uploadAddressFocus',
  component: lazy(() => import(/* webpackChunkName: 'snackMachine/uploadAddressFocus' */ '../pages/uploadAddressFocus/home')),
  exact: true
}];

export default UploadAddress;
